import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import RestaurantsSection from '../components/RestaurantsSection'
import CreateRestaurantModal from '../components/CreateRestaurantModal'
import { useTranslation } from '../hooks/use-i18n'

const RestaurantsList: React.FC = () => {
  const { t } = useTranslation()
  const [refreshKey, setRefreshKey] = useState(0)
  const [showCreateRestaurant, setShowCreateRestaurant] = useState(false)

  return (
    <div className="min-h-screen">
      <main className="max-w-7xl mx-auto px-3 sm:px-4 lg:px-8 py-4 sm:py-6 lg:py-8">
        <div className="flex flex-col sm:flex-row sm:justify-between sm:items-start gap-4 mb-6 sm:mb-8">
          <div>
            <h1 className="text-2xl sm:text-3xl font-bold text-white mb-2">{t('nav.restaurant')}</h1>
            <p className="text-white/60 text-sm sm:text-base">{t('dashboard.subtitle')}</p>
          </div>
          <button
            type="button"
            onClick={() => setShowCreateRestaurant(true)}
            className="bg-gradient-to-r from-blue-500 to-blue-600 hover:from-blue-600 hover:to-blue-700 text-white px-6 py-2.5 rounded-lg font-semibold text-sm sm:text-base w-full sm:w-auto"
          >
            {t('dashboard.createButton')}
          </button>
        </div>

        <RestaurantsSection refreshKey={refreshKey} onOpenCreate={() => setShowCreateRestaurant(true)} />

        <p className="mt-8 text-center text-sm text-white/40">
          <Link to="/dashboard" className="hover:text-white/70 underline">
            {t('nav.home')}
          </Link>
        </p>
      </main>

      {showCreateRestaurant && (
        <CreateRestaurantModal
          onClose={() => setShowCreateRestaurant(false)}
          onSuccess={() => {
            setShowCreateRestaurant(false)
            setRefreshKey((k) => k + 1)
          }}
        />
      )}
    </div>
  )
}

export default RestaurantsList
